var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCafMakeappt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "370px",
    height: "208px",
    viewBox: "0 0 370 208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CAF-assistancetile-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Iteration-9/07/21-career-edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personalised-assistance-box-old-tiles",
    transform: "translate(0.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CAF-assistancetile-1",
    transform: "translate(0.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F4F7F9",
    x: 0,
    y: 0,
    width: 370,
    height: 208
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(149.000000, 68.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Brand/48px/Calendar",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5,6 L63,6 L63,9 L67.5,9 C68.3284271,9 69,9.67157288 69,10.5 L69,18 L3,18 L3,10.5 C3,9.67157288 3.67157288,9 4.5,9 L12,9 L12,13.395 C12,14.2234271 12.6715729,14.895 13.5,14.895 C14.3284271,14.895 15,14.2234271 15,13.395 L15,1.5 C15,0.671572875 14.3284271,0 13.5,0 C12.6715729,0 12,0.671572875 12,1.5 L12,6 L4.5,6 C2.01471863,6 0,8.01471863 0,10.5 L0,61.5 C0,63.9852814 2.01471863,66 4.5,66 L67.5,66 C69.9852814,66 72,63.9852814 72,61.5 L72,10.5 C72,8.01471863 69.9852814,6 67.5,6 Z M67.5,63 L4.5,63 C3.67157288,63 3,62.3284271 3,61.5 L3,21 L69,21 L69,61.5 C69,62.3284271 68.3284271,63 67.5,63 Z",
    id: "Shape",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,13.5 C27,14.3284271 27.6715729,15 28.5,15 C29.3284271,15 30,14.3284271 30,13.5 L30,1.5 C30,0.671572875 29.3284271,0 28.5,0 C27.6715729,0 27,0.671572875 27,1.5 L27,6 L18,6 L18,9 L27,9 L27,13.5 Z",
    id: "Path",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,13.5 C42,14.3284271 42.6715729,15 43.5,15 C44.3284271,15 45,14.3284271 45,13.5 L45,1.5 C45,0.671572875 44.3284271,0 43.5,0 C42.6715729,0 42,0.671572875 42,1.5 L42,6 L33,6 L33,9 L42,9 L42,13.5 Z",
    id: "Path",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,13.5 C57,14.3284271 57.6715729,15 58.5,15 C59.3284271,15 60,14.3284271 60,13.5 L60,1.5 C60,0.671572875 59.3284271,0 58.5,0 C57.6715729,0 57,0.671572875 57,1.5 L57,6 L48,6 L48,9 L57,9 L57,13.5 Z",
    id: "Path",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 12,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 24,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 36,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 48,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 60,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 12,
    cy: 42,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 24,
    cy: 42,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 36,
    cy: 42,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 60,
    cy: 42,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 12,
    cy: 54,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 24,
    cy: 54,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 36,
    cy: 54,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 48,
    cy: 54,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#002664",
    cx: 60,
    cy: 54,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,42 C55.5,46.1421356 52.1421356,49.5 48,49.5 C43.8578644,49.5 40.5,46.1421356 40.5,42 C40.5,37.8578644 43.8578644,34.5 48,34.5 C52.1421356,34.5 55.5,37.8578644 55.5,42 Z",
    id: "Path",
    fill: "#D7153A"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafMakeappt);
export default __webpack_public_path__ + "static/media/CAF-makeappt.8f1305928128967e9988064158b22282.svg";
export { ForwardRef as ReactComponent };